import { AxiosRequestConfig, Method } from 'axios'

import axiosInstance from '../lib/api/axiosInstance'

import { RequestConfig } from './types'

export default abstract class AbstractService {
  async request<T>(
    path: string,
    method: Method = 'get',
    isShowLoader?: boolean,
    data?: unknown,
    config?: RequestConfig,
    convertFn?: (data: unknown) => T,
  ): Promise<T> {
    try {
      const tempConfig: RequestConfig = {
        method,
        url: path,
        data,
        isShowLoader,
        ...config,
      }

      const { data: configData } = await axiosInstance.request(tempConfig)

      return typeof convertFn === 'function' ? convertFn(configData) : (configData as T)
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message)
    }
  }

  async rawRequest<T>({ url, ...config }: AxiosRequestConfig) {
    try {
      const res = await axiosInstance.request<T>({
        url,
        ...config,
      })

      return res
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message)
    }
  }

  async getBlobWithFilename<T>({
    url,
    fileType = 'csv',
    ...config
  }: { fileType?: string } & AxiosRequestConfig) {
    try {
      const { data: blob, headers } = await this.rawRequest<T>({
        url,
        method: 'get',
        responseType: 'blob',
        ...config,
      })

      const filename = headers['x-suggested-filename'] || 'file.csv'

      return { blob, filename }
    } catch (err) {
      throw new Error(err)
    }
  }
}
